<template>
  <workspace-layout>
    <div class="dashboard-wrapper">
      <a-row :gutter="16">
        <a-col
          :xs="24"
          :md="24"
          :lg="24"
          :xl="24"
          :xxl="8"
          style="margin-bottom: 16px;">
          <a-row :gutter="16" type="flex" justify="space-between">
            <!-- 项目动态 -->
            <a-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12"
              :xl="12"
              :xxl="24">
              <div class="moments x-card">
                <h3>项目动态</h3>
                <div class="moments-wrapper">
                  <div v-if="!projectMoments.length" class="no-data">
                    <a-icon type="frown-o" />暂无数据
                  </div>
                  <a-timeline v-else>
                    <template v-for="(item, index) in projectMoments">
                      <a-timeline-item :key="index">
                        <a-tag color="#FDE9EA">
                          <span style="color: #F4282D;">{{ item.created_at | moment }}</span>
                        </a-tag>
                        <div>
                          <router-link
                            :to="{ name: 'ProjectDetail', params: { projectId: item.project.id } }"
                          >
                            <div class="project-link">{{ item.project.name }}</div>
                          </router-link>
                          {{ item.content.split(item.project.name).join('') }}
                        </div>
                      </a-timeline-item>
                    </template>
                    <div style="margin-top: 30px">
                      <a-button
                        v-if="projectMomentPagination.count > projectMoments.length"
                        @click="showMore">加载更多 ▼</a-button>
                      <a-button v-else disabled block>没有更多动态了</a-button>
                    </div>
                  </a-timeline>
                </div>
              </div>
            </a-col>
            <!-- 我的收藏 -->
            <a-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="12"
              :xl="12"
              :xxl="24">
              <div class="collection x-card">
                <h3>
                  我的收藏
                  <a-radio-group
                    @change="onChange"
                    v-model="favoritesType"
                    defaultValue="all"
                    size="small"
                    buttonStyle="solid"
                  >
                    <a-radio-button value="all">不限</a-radio-button>
                    <a-radio-button value="projects">项目</a-radio-button>
                    <a-radio-button value="demands">需求</a-radio-button>
                  </a-radio-group>
                </h3>
                <div class="collections-wrapper">
                  <div v-if="!favorites.length" class="no-data">
                    <a-icon type="frown-o" />暂无数据
                  </div>
                  <template v-else>
                    <a-list itemLayout="horizontal" :dataSource="favorites">
                      <a-list-item
                        slot="renderItem"
                        slot-scope="item"
                        :key="`${item.type}-${item.id}`"
                      >
                        <div class="favorite">
                          <div class="type">
                            <a-tag color="blue" v-if="item.collectableType==='Demand'">需求</a-tag>
                            <a-tag color="pink" v-else-if="item.collectableType==='Project'">项目</a-tag>
                          </div>
                          <div
                            class="name"
                          >{{ item.collectable.name }}</div>
                          <router-link
                            :to="{ Demand: { name: 'DemandDetail', params: { demandId: item.collectable.id } }, Project: { name: 'ProjectDetail', params: { projectId: item.collectable.id } } }[item.collectableType]"
                            class="link"
                          >详情</router-link>
                        </div>
                      </a-list-item>
                      <div style="margin-top: 15px;text-align: right">
                        <a-pagination
                          :current="favoritesPagination.pageNo"
                          :total="favoritesPagination.count"
                          :pageSize.sync="favoritesPagination.pageSize"
                          @change="favoritesPageChange"
                        />
                      </div>
                    </a-list>
                  </template>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-col>

        <a-col
          :gutter="16"
          :xs="24"
          :md="24"
          :lg="24"
          :xl="24"
          :xxl="16">
          <a-row>
            <!-- 系统通知 -->
            <a-col :span="24">
              <div
                v-if="notifications && notifications.length > 0"
                class="notifications-wrapper x-card"
              >
                <h3>
                  系统通知
                  <div>
                    <a-popconfirm title="确定将本页消息全部置为已读？" @confirm="markRead('all')">
                      <a-button type="primary" icon="issues-close">标记本页已读</a-button>
                    </a-popconfirm>
                  </div>
                </h3>
                <a-list
                  itemLayout="horizontal"
                  :dataSource="notifications"
                  :locale="{ emptyText: '暂无新消息' }"
                >
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <div
                      :class="['notification', !item.is_read && 'active']"
                      :key="item.id"
                      @click="markRead('single', index)"
                    >
                      <a-row :gutter="8" type="flex" justify="space-between" align="top">
                        <!-- 通知内容 -->
                        <a-col :span="16">
                          <div class="content">
                            <span v-html="item.content"></span>
                          </div>
                        </a-col>
                        <!-- 查看 -->
                        <a-col :span="4">
                          <template v-if="item['scene'] && item['relevant_id']">
                            <div class="action">
                              <a-button
                                v-if="!(isProjectManager && item.scene === 'applying_for_manager')"
                                type="dashed"
                                size="small"
                                style="color: #1890ff;"
                                @click="viewNotification(item)"
                              >查看</a-button>
                            </div>
                          </template>
                        </a-col>
                        <!-- 时间 -->
                        <a-col :span="4">
                          <div class="date">{{ item.created_at | moment }}</div>
                        </a-col>
                      </a-row>
                    </div>
                  </a-list-item>
                </a-list>
                <div style="margin-top: 15px;text-align: right">
                  <a-pagination
                    :defaultCurrent="notificationPagination.pageNo"
                    :pageSize.sync="notificationPagination.pageSize"
                    :total="notificationPagination.count"
                    @change="pageChange"
                  />
                </div>
              </div>
            </a-col>
            <!-- 我的项目 -->
            <a-col :span="24">
              <div class="projects x-card">
                <h3>我的项目</h3>
                <div v-if="!projects.length && filters.scope=== 'all'" class="no-data">
                  <a-row>
                    <a-col :xs="24" :md="{span: 16, offset: 4}" :lg="{span: 8, offset: 8}">
                      <no-data-guide></no-data-guide>
                    </a-col>
                  </a-row>
                </div>
                <template v-else-if="!projects.length && projects !== 'all'">
                  <x-filter :filters="filtersConfig" @chosen="chosen"></x-filter>
                  <div class="no-data">
                    <a-icon type="frown-o" />暂无数据
                  </div>
                </template>
                <template v-else>
                  <x-filter :filters="filtersConfig" @chosen="chosen"></x-filter>
                  <a-list
                    class="project-list"
                    :grid="{ gutter: 16, column: 3 }"
                    :dataSource="projects"
                    :locale="{ emptyText: '暂无数据' }"
                  >
                    <a-list-item slot="renderItem" slot-scope="item">
                      <project-item :data="item" :key="item.id"></project-item>
                    </a-list-item>
                  </a-list>
                  <div style="margin-top: 15px;text-align: right">
                    <a-pagination
                      :current="projectsPagination.pageNo"
                      :total="projectsPagination.count"
                      :pageSize.sync="projectsPagination.pageSize"
                      @change="projectsPageChange"
                    />
                  </div>
                </template>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </workspace-layout>
</template>

<script>
import { mapState } from 'vuex'
import { Favorites, Notifications, Projects, ProjectMoments } from '@/resources'
import { mixin } from '@/utils/mixin'
import { createViewRoute } from '@/views/account/settings/notificationUtil'
import WorkspaceLayout from '@/components/page/WorkspaceLayout'
import xFilter from '@/components/xFilter'
import ProjectItem from '@/components/ProjectItem'
import NoDataGuide from '@/views/workspace/Dashboard/NoDataGuide'

export default {
  mixins: [mixin],
  components: {
    WorkspaceLayout,
    xFilter,
    ProjectItem,
    NoDataGuide
  },
  data () {
    return {
      filters: {
        scope: 'all'
      },
      filtersConfig: [
        {
          title: '项目类型',
          key: 'scope',
          default: 'all',
          options: [
            {
              label: '不限',
              value: 'all'
            },
            {
              label: '我发起的项目',
              value: 'owned'
            },
            {
              label: '参与中的项目',
              value: 'participated'
            },
            {
              label: '申请中的项目',
              value: 'applying'
            }
          ]
        }
      ],
      favorites: [],
      projects: [],
      favoritesType: 'all',
      favoritesPagination: {
        pageNo: 1,
        pageSize: 6,
        count: 0
      },
      projectMomentPagination: {
        pageNo: 1,
        pageSize: 15,
        count: 0
      },
      notificationPagination: {
        pageNo: 1,
        pageSize: 4,
        count: 0
      },
      projectsPagination: {
        pageNo: 1,
        pageSize: 6,
        count: 0
      },
      projectMoments: [],
      notifications: []
    }
  },
  computed: {
    ...mapState({
      basicInfo: state => state.user.basicInfo
    })
  },
  mounted () {
    const vm = this
    vm.fetchProjectMoment()
    // vm.fetchNotifications()
    vm.fetchFavorites()
    vm.fetchProjects()
  },
  methods: {
    favoritesPageChange (current) {
      const vm = this
      vm.favoritesPagination.pageNo = current
      vm.fetchFavorites()
    },
    onChange () {
      const vm = this
      vm.favoritesPagination = {
        pageNo: 1,
        pageSize: 6,
        count: 0
      }
      vm.fetchFavorites()
    },
    markRead (range, index) {
      if (range === 'all') {
        new Promise(resolve => {
          Promise.all(this.notifications.map(({ id }) => Notifications.read(id))).then(() => {
            resolve()
          })
        }).then(() => {
          this.notificationPagination = {
            pageNo: 1,
            pageSize: 8,
            count: 0
          }
          this.fetchNotifications()
          this.resetUnreadNotificationsCount()
        })
      } else {
        Notifications.read(this.notifications[index].id).then(() => {
          this.resetUnreadNotificationsCount()
        })
        this.notifications.splice(index, 1)
      }
    },
    pageChange (current) {
      const vm = this
      vm.notificationPagination.pageNo = current
      vm.fetchNotifications()
    },
    async fetchProjectMoment () {
      const { projectMoments: moments, count } = await ProjectMoments.list(this.projectMomentPagination)
      this.projectMoments.push(...moments)
      this.projectMomentPagination.count = count
    },
    async fetchFavorites () {
      let params = { ...this.favoritesPagination }
      if (this.favoritesType !== 'all') {
        params = { ...params, category: this.favoritesType }
      }
      const { favorites, count } = await Favorites.list(params)
      this.favorites = favorites
      this.favoritesPagination.count = count
    },
    async fetchNotifications () {
      const { notifications, count } = await Notifications.list(Object.assign({ is_read: 'no' }, this.notificationPagination))
      this.notifications = notifications
      this.notificationPagination.count = count
    },
    showMore () {
      const vm = this
      vm.projectMomentPagination.pageNo++
      vm.fetchProjectMoment()
    },
    async fetchProjects () {
      const { projects, count } = await Projects.listOfMine({ ...this.projectsPagination, ...this.filters })
      this.projects = projects
      this.projectsPagination.count = count
    },
    chosen ({ key, value }) {
      const vm = this
      vm.filters[key] = value
      vm.projectsPagination = {
        pageNo: 1,
        pageSize: 6,
        count: 0
      }
      vm.fetchProjects()
    },
    projectsPageChange (current) {
      const vm = this
      vm.projectsPagination.pageNo = current
      vm.fetchProjects()
    },
    resetUnreadNotificationsCount () {
      Notifications
        .getUnreadCount()
        .then(data => {
          const count = data.count
          this.$store.dispatch('SetCounts', { notification_count: count })
        })
        .catch(error => {
          console.error('获取未读通知数出错', error)
        })
    },
    viewNotification (notification) {
      const route = createViewRoute(notification)
      this.$router.push(route)
    }
  }
}
</script>

<style lang="less" scoped>
.dashboard-wrapper {
  .moments {
    margin-bottom: 16px;
    .moments-wrapper {
      height: 350px;
      min-height: 200px;
      overflow: auto;
      .project-link {
        padding: 10px 0;
        font-size: 16px;
        font-weight: 700;
        color: #666;
        &:hover {
          color: #c8161e;
        }
      }
    }
  }
  .collection {
    .collections-wrapper {
      height: 350px;
    }
    .favorite {
      width: 100%;
      display: flex;
      .type {
      }
      .name {
        flex-grow: 1;
        margin: 0 10px;
      }
      .link {
        min-width: 40px;
      }
    }
  }

  .notifications-wrapper {
    margin-bottom: 16px;
    .notification {
      width: 100%;
      padding-left: 30px;
      position: relative;
      &.active {
        cursor: pointer;
        &:before {
          display: block;
        }
      }
      &:before {
        display: none;
        content: '';
        position: absolute;
        left: 10px;
        top: 10px;
        width: 6px;
        border-radius: 50%;
        height: 6px;
        background-color: #e9423d;
      }
      .content {
        font-size: 14px;
        color: rgba(131, 146, 167, 1);
        display: inline;
      }
      .action {
        text-align: right;
      }
      .date {
        font-size: 12px;
        color: #999;
        text-align: right;
      }
    }
  }
  .projects {
    min-height: 600px;
  }
}

.no-data {
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}
</style>
